type Props = {
    text?: string,
  };

export function Label({text = ''}: Props) {
    return <p className="text-sm font-extrabold">{ text }:</p>
}